import { hot } from "react-hot-loader/root";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RejectedBusinessPartnersComponent from "./components";

import { setMenuKey } from "../../actions";

import { fetchLookUp } from "../BusinessPartnerDetails/store/actions";

import { fetchRejectedBP } from "./store/actions";

const mapStateToProps = ({ app, rejectedBusinessPartner, businessPartner }) => ({
  statuses: businessPartner.statuses,
  rejectedBPlist: rejectedBusinessPartner.rejectedBPlist,
  pageInfo: rejectedBusinessPartner.pageInfo,
  viewport: app.viewport,
  pseudoroleValueCodeMap: businessPartner.pseudoroleValueCodeMap

});

const mapDispatchToProps = {
  setMenuKey,
  fetchLookUp,
  fetchRejectedBP
};

const RejectedBusinessPartners = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(hot(RejectedBusinessPartnersComponent))
);

export default RejectedBusinessPartners;
